import { Product } from '../../models/Product'

const mutations = {
  addProduct(state: any, product: Product) {
    state.list.push(product)
  },
  setProductList(state: any, products: Product[]) {
    state.list = products
  },
  clearProducts(state: any) {
    state.list = []
  },
  setSelectedProduct(state: any, product: Product ) {
    state.selectedProduct = product
  },
  clearSelectedProduct(state: any) {
    state.selectedProduct = null
  },
  setFilterParameter(state: any, filterParameter: string) {
    state.filterParameter = filterParameter
  },
  loading(state: any, loading: boolean) {
    state.loading = loading
  }
}

const getters = {
  /*
  * Category IDs:
  * 1 - General
  * 2 - Exterior
  * 3 - Interior
  * 4 - Package
  */

  products: (state: any) => {
    if (!(state.filterParameter.length > 0)) {
      return [...state.list].sort((a: Product, b: Product) => (a.featured < b.featured) ? 1: -1)
    } else {
        const filteredProducts : Product[] = []
        state.list.forEach((product: Product) => {
          if (product.number.toLowerCase().includes(state.filterParameter)) {
            filteredProducts.push(product)
          } else if (product.name.toLowerCase().includes(state.filterParameter)) {
            filteredProducts.push(product)
          }
        })
        
      return filteredProducts
    }
  },
  featuredProducts:(state: any) => {
    return state.list.filter((product : Product) : boolean => { return product.featured === 1 })
  },
  featuredProductsLength: (state: any) => {
    return state.list.filter((product : Product) : boolean => { return product.featured === 1 }).length
  },
  exteriorProducts: (state: any) => {
    return state.list.filter((product: Product) : boolean => { return product.categoryId === 2 })
  },
  interiorProducts: (state: any) => {
    return state.list.filter((product: Product) : boolean => { return product.categoryId === 3 })
  },
  packages: (state: any) => {
    return state.list.filter((product: Product) : boolean => { return product.categoryId === 4 })
  },
  selectedProduct:(state: any) => {
    return state.selectedProduct
  },
  loading: (state: any) => {
    return state.loading
  },
  numProducts: (state: any) => {
    return state.list.length
  }
}

const actions = {
  async loadProducts(context : any, args : any) {
    context.commit('loading', true)
    context.commit('clearProducts')

    const res = await Product.getProducts(args.trimId, args.dealerId)

    const products : Product[] = []

    res.forEach((product: Product) => {
      products.push(product)
    })

    context.commit('setProductList', products)
    context.commit('loading', false)
  },
  async loadProduct(context : any, args: any) {
    context.commit('loading', true)

    const product : Product | null = await Product.getProduct(args.productId, args.dealerId)

    if (product) {
      context.commit('setSelectedProduct', product)
    }

    context.commit('loading', false)
  },
  async reloadProducts(context: any, args: any) {
    context.dispatch('loadProducts', args)
  },
}

const state = () => ({
  list: [] as Product[],
  selectedProduct: null as Product | null,
  filterParameter: '' as string,
  loading: false
})

export default {
    namespaced: true,
    mutations,
    getters,
    state,
    actions,
}
